<template>
    <div class="map-content">
        <div ref="map" :id="`map${number}`"></div>
    </div>
</template>

<script>
    import {bus} from "../../main";
    import {checkEquality, fullCopy} from "../../plugins/methods";
    import * as typesGlobal from '@/stores/types';

    const style = `
    <style>
    * {
        margin: 0;
        padding: 0;
    }
    .leaflet-div-icon {
        border: unset;
        background: unset;
    }
    .marker {
        white-space: nowrap;
        position: absolute;
        left: 4px;
        bottom: 22px;
        transform: translateX(-50%);
        padding: 6px;
        background: var(--white-color);
        border: 1px solid var(--primary-color);
        border-radius: 3px;
        box-sizing: border-box;
        box-shadow: 4px 4px 7px rgba(0, 0, 0, 0.2);
        transition: all .2s;
    }
    .marker.active,
    .marker.hover:hover {
        background: var(--primary-color);
    }
    .marker .bottom-angle {
        position: absolute;
        left: calc(50% - 10px);
        top: calc(100% - 1px);
        border-top: 14px solid var(--white-color);
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        transition: all .2s;
    }
    .marker.active .bottom-angle,
    .marker.hover:hover .bottom-angle {
        border-top: 14px solid var(--primary-color);
    }
    .marker .bottom-angle:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        transform-origin: 0 0;
        transform: rotate(-130deg);
        width: 16px;
        height: 1px;
        background: var(--primary-color);
    }
    .marker .bottom-angle:after {
        content: "";
        position: absolute;
        left: 0;
        top: -1px;
        transform-origin: 0 0;
        transform: rotate(-53deg);
        width: 15px;
        height: 1px;
        background: var(--primary-color);
    }
    .marker .label {
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        color: var(--dark-1-color);
        transition: all .2s;
    }
    .marker.active .label,
    .marker.hover:hover .label {
        color: var(--white-color);
    }
</style>
    `;

    export default {
        name: "tour-map",
        data() {
            return {
                mymap: {},
                markers: [],
                selectedHotels: [],
                selectedHotelsOnMap: [],
                mapItemsOld: [],
                L: null,
                minPriceItem: {Cost: 0},
                zoomIsSet: false
            }
        },
        props: {
            mapItems: {
                type: Array,
                default: () => []
            },
            rate: {
                type: Object,
                default: () => {}
            },
            focused: {
                type: Object,
                default: null
            },
            focusedInListView: {
                type: Object,
                default: null
            },
            number: {
                type: Number,
                default: 1
            },
            showOnlySelected: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            isDarkTheme() {
                return this.$store.getters["getTheme"]
            },
            isFocusedInListViewHasCoord() {
              return this.focusedInListView && this.focusedInListView.Latitude && this.focusedInListView.Longitude
            }
        },
        created() {
            bus.$on("localizeCode", () => {
                setTimeout(() => {
                    this.addMarkers()
                }, 100)
            });
        },
        mounted() {
            /* Импортируем библиотеку карты */
            this.L = window.L;

            /* Создаем обект карты */
            this.mymap = this.L.map(`map${this.number}`, {
                center: [0, 0],
                zoom: 2,
                maxZoom: 17,
                minZoom: 2,
            });

            const southWest = this.L.latLng(-89.98155760646617, -180),
                northEast = this.L.latLng(89.99346179538875, 180);
            const bounds = this.L.latLngBounds(southWest, northEast);

            this.mymap.setMaxBounds(bounds);
            this.mymap.on('drag', () => {
                this.mymap.panInsideBounds(bounds, { animate: false });
            });

            /* Создаем ссылку в правом нижнем углу (обязательно)*/
            this.setTheme();
            // const theme = this.isDarkTheme ? "dark" : "sunny"
            // const accessToken = 'pD6fV2P30j5QRPG9Ui3RmJxhZLMUVqsYa5p7SXhsDR88zlMTGHUyAJmPQSo24at8';
            // const attribution = '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank" class="jawg-attrib">&copy; <b>Jawg</b>Maps</a> | <a href="https://www.openstreetmap.org/copyright" title="OpenStreetMap is open data licensed under ODbL" target="_blank" class="osm-attrib">&copy; OSM contributors</a>';
            // const tileUrl = `https://tile.jawg.io/jawg-${theme}/{z}/{x}/{y}.png?access-token=${accessToken}`;
            // const tiles = this.L.tileLayer(tileUrl, {attribution});
            // tiles.addTo(this.mymap);

            this.addMarkers();

            this.mymap.on('click', () => {
                if (this.showOnlySelected)
                    return;

                this.removeMarkers();
                this.setSelectedHotels();

                window.selectedMapItem = null;

                const repeatedCoordinates = [];
                const helper = [];
                this.mapItems?.forEach((x, i) => {
                    // if (!x.coordinates) {
                    //     return
                    // }

                    x?.Services.forEach(x2 => {
                        if (x2.SvKey !== 3) return;

                        const coordinates = this.getHotelCoordinates(x2).join("_");

                        if (helper.includes(coordinates)) {
                            let index = repeatedCoordinates.map(x3 => x3.coordinates).indexOf(coordinates);
                            if (index !== -1) {
                                repeatedCoordinates[index].count++
                            } else {
                                repeatedCoordinates.push({
                                    mapItemIndex: i,
                                    count: 2,
                                    isUsed: false,
                                    coordinates: coordinates
                                })
                            }
                        } else {
                            helper.push(coordinates)
                        }
                    });
                });

                this.mapItems?.forEach((x2) => {
                    // if (!x2.coordinates) {
                    //     return
                    // }

                    x2?.Services.forEach(x3 => {
                        if (
                            x3.SvKey !== 3 ||
                            isNaN(this.getHotelCoordinates(x3)[0]) ||
                            this.selectedHotels.length && !this.selectedHotels.includes(x3.Hotel.Key)
                        ) return;

                        const coordinates = this.getHotelCoordinates(x3).join("_");
                        let repeatedIndex = repeatedCoordinates.map(x4 => x4.coordinates).indexOf(coordinates);

                        if (repeatedIndex !== -1) {
                            if (!repeatedCoordinates[repeatedIndex].isUsed) {
                                repeatedCoordinates[repeatedIndex].isUsed = true;
                                x2.count = repeatedCoordinates[repeatedIndex].count;
                            } else {
                                return;
                            }
                        }

                        x2.open = this.selectedHotelsOnMap.includes(x3.Hotel.Key);

                        const myIcon = this.L.divIcon({html: this.markerHtml(x2, x3)});
                        this.markers.push(this.L.marker(this.getHotelCoordinates(x3), {icon: myIcon}).addTo(this.mymap));
                    });
                });
                this.selectHotel();

                this.setMarkersEvent();
            })
        },
        methods: {
            setTheme() {
                const theme = this.isDarkTheme ? "dark" : "sunny"
                const accessToken = 'pD6fV2P30j5QRPG9Ui3RmJxhZLMUVqsYa5p7SXhsDR88zlMTGHUyAJmPQSo24at8';
                const attribution = '<a href="http://jawg.io" title="Tiles Courtesy of Jawg Maps" target="_blank" class="jawg-attrib">&copy; <b>Jawg</b>Maps</a> | <a href="https://www.openstreetmap.org/copyright" title="OpenStreetMap is open data licensed under ODbL" target="_blank" class="osm-attrib">&copy; OSM contributors</a>';
                const tileUrl = `https://tile.jawg.io/jawg-${theme}/{z}/{x}/{y}.png?access-token=${accessToken}`;
                const tiles = this.L.tileLayer(tileUrl, {attribution});
                tiles.addTo(this.mymap);
            },
            selectHotel(hotelsKey) {
                bus.$emit("map_selected_hotel", hotelsKey || null);
            },
            getHotelCoordinates(hotel) {
                return [
                    parseFloat(hotel.Latitude),
                    parseFloat(hotel.Longitude)
                ];
            },
            equalArray(arr1, arr2) {
                let isEqual = true;
                arr1.forEach((x,i) => {
                    if (x !== arr2[i]) isEqual = false
                });

                return isEqual
            },
            setHotel(item, coordinates) {
                const hotelsKey = item.Services
                    .find(x => x.SvKey === 3 && this.equalArray(this.getHotelCoordinates(x), coordinates))
                    .Hotel.Key;

                this.selectHotel(hotelsKey);
            },
            correctPrice(val) {
                const isFloat = val % 1 !== 0;
                let res = new Intl.NumberFormat().format(val);

                if (res.includes(".") || !isFloat) {
                    res = res.replace(/,/g, " ");
                } else {
                    res = res.replace(/,/g, ".");
                }
                res = (res.includes("NaN") || isNaN(parseInt(res))) ? "" : res;
                return res
            },
            showPopover(text, rect) {
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text
                };
                this.$store.dispatch(typesGlobal.A_SHOW_POPOVER, res);
                document.querySelector('.popover-title').style.maxWidth = '250px';
                document.querySelector('.popover-title').style.overflowWrap = "break-word";
            },
            hidePopover() {
                this.$store.dispatch('A_HIDE_POPOVER');
            },
            removeMarkers() {
                this.markers.forEach(x => {
                    this.mymap.removeLayer(x);
                });
                this.markers = [];
            },
            setSelectedHotels() {
                this.selectedHotels = [];
                this.selectedHotelsOnMap = [];
                const params = this.$route.fullPath.split("&");
                let selectedHotelsOnMap = params.find(x => x.includes("hotelOnMap="));
                if (selectedHotelsOnMap) {
                    this.selectedHotelsOnMap = selectedHotelsOnMap
                        .split("=")[1]
                        .split(",")
                        .map(x => +x)
                }
                let selectedHotels = params.find(x => x.includes("hotels="));
                if (selectedHotels) {
                    this.selectedHotels = selectedHotels
                        .split("=")[1]
                        .split(",")
                        .map(x => +x)
                }
            },
            setMarkersEvent() {
                this.markers.forEach((x, i) => {
                    x.on('click', () => {
                        if (this.showOnlySelected)
                            return;

                        this.removeMarkers();
                        this.setSelectedHotels();

                        const repeatedCoordinates = [];
                        const helper = [];
                        const markerGroup = [];
                        this.mapItems?.forEach((x2, i2) => {
                            // if (!x2.coordinates) {
                            //     return
                            // }

                            x2?.Services.forEach(x3 => {
                                if (x3.SvKey !== 3) return;

                                const coordinates = this.getHotelCoordinates(x3).join("_");
                                if (x._latlng.lat + "_" + x._latlng.lng === coordinates) {
                                    markerGroup.push(x2);
                                }

                                if (helper.includes(coordinates)) {
                                    let index = repeatedCoordinates.map(x4 => x4.coordinates).indexOf(coordinates);
                                    if (index !== -1) {
                                        repeatedCoordinates[index].count++
                                    } else {
                                        repeatedCoordinates.push({
                                            mapItemIndex: i2,
                                            count: 2,
                                            isUsed: false,
                                            coordinates: coordinates
                                        })
                                    }
                                } else {
                                    helper.push(coordinates)
                                }
                            });
                        });

                        let key2 = 0;
                        let selected = false;
                        this.mapItems?.forEach((x2) => {
                            // if (!x2.coordinates) {
                            //     return
                            // }

                            x2?.Services.forEach(x3 => {
                                if (
                                    x3.SvKey !== 3 ||
                                    isNaN(this.getHotelCoordinates(x3)[0]) ||
                                    this.selectedHotels.length && !this.selectedHotels.includes(x3.Hotel.Key)
                                ) return;

                                const coordinates = this.getHotelCoordinates(x3).join("_");
                                let repeatedIndex = repeatedCoordinates.map(x4 => x4.coordinates).indexOf(coordinates);

                                if (repeatedIndex !== -1) {
                                    if (!repeatedCoordinates[repeatedIndex].isUsed) {
                                        repeatedCoordinates[repeatedIndex].isUsed = true;
                                        x2.count = repeatedCoordinates[repeatedIndex].count;
                                    } else {
                                        return;
                                    }
                                }
                                key2++;

                                x2.open = x2.open ? false : i === key2-1;

                                if (x2.open) {
                                    this.setHotel(x2,this.getHotelCoordinates(x3));
                                    selected = true;
                                }

                                if (i === key2-1) {
                                    x2.markerGroup = [...markerGroup]
                                }

                                const myIcon = this.L.divIcon({html: this.markerHtml(x2, x3)});
                                this.markers.push(this.L.marker(this.getHotelCoordinates(x3), {icon: myIcon}).addTo(this.mymap));
                            });
                        });

                        if (!selected) {
                            this.selectHotel();
                        }

                        // this.markers[i].setZIndexOffset(1000);

                        this.setMarkersEvent();
                    });
                });
                var self = this;
                document.querySelectorAll('.marker').forEach(function(m) {
                    m.addEventListener('mouseover', () => {
                        let hotelName = m.querySelector('span').textContent;
                        self.showPopover(hotelName, m.getBoundingClientRect());
                    });
                    m.addEventListener('mouseout', () => {
                        self.hidePopover();
                    });
                });
            },
            getSelectedHotelsCoordinates() {
                const res = [];
                const hotelKey = this.selectedHotelsOnMap[0];
                this.mapItems.forEach(x => {
                    x.Services.forEach(x2 => {
                        const isHotel = x2.SvKey === 3;
                        if (!isHotel) return;

                        if (x2.Hotel.Key === hotelKey) {
                            res.push(parseFloat(x2.Latitude));
                            res.push(parseFloat(x2.Longitude));
                        }
                    })
                });
                return res;
            },
            setCenterToMinPrice() {
                const hasCoordinates = this.mapItems.filter(x => x?.coordinates);
                let center = [];
                if (this.focusedInListView) {
                  center = this.getHotelCoordinates(this.focusedInListView);
                    if (!this.zoomIsSet) {
                          this.mymap.setZoom(16);
                    }
                    this.mymap.panTo(new this.L.LatLng(...center));
                } else if (this.minPriceItem?.coordinates && hasCoordinates) {
                    center = [
                    +this.minPriceItem.coordinates[0].toFixed(3),
                    +this.minPriceItem.coordinates[1].toFixed(3)
                    ];
                    if (this.selectedHotelsOnMap &&
                          this.getSelectedHotelsCoordinates().length &&
                          !isNaN(this.getSelectedHotelsCoordinates()[0])) 
                          {
                          center = this.getSelectedHotelsCoordinates()
                          }
                    if (!this.zoomIsSet) {
                          this.mymap.setZoom(16);
                    }
                    this.mymap.panTo(new this.L.LatLng(...center));
                } else if (this.focusedInListView && !this.minPriceItem?.coordinates && !hasCoordinates) {
                    if (this.number === 2 && this.isFocusedInListViewHasCoord) {
                    center = this.getHotelCoordinates(this.focusedInListView);
                    }
                    if (this.focusedInListView && !this.focusedInListView.Latitude && !this.focusedInListView.Longitude) {
                        this.mymap.setZoom(2);
                        this.mymap.panTo(new this.L.LatLng(0,0));
                    } else {
                        this.mymap.setZoom(16);
                    }
                    this.mymap.panTo(new this.L.LatLng(...center));
                } else {
                    if (!this.mapItems.length || this.mapItems.some(x => !x)) return
                    const firstFoundArrItemsWithCoord = this.mapItems.find(x => {
                        return x.Services.find(x2 => x2.Latitude && x2.Longitude);
                    })
                    if (!firstFoundArrItemsWithCoord) return
                    const itemWithCoord = firstFoundArrItemsWithCoord.Services.find(x => x.Latitude && x.Longitude);
                    center = this.getHotelCoordinates(itemWithCoord);
                    this.mymap.setZoom(16);
                    this.mymap.panTo(new this.L.LatLng(...center));
                }
            },
            addMarkers() {
              if (this.number === 2 && !this.isFocusedInListViewHasCoord) {
                this.removeMarkers();
                return
              }
                this.removeMarkers();
                this.setSelectedHotels();

                const repeatedCoordinates = [];
                const helper = [];
                this.mapItems?.forEach((x, i) => {
                    // if (!x?.coordinates) {
                    //     return
                    // }
                    x?.Services.forEach(x2 => {
                        if (x2.SvKey !== 3) return;

                        const coordinates = this.getHotelCoordinates(x2).join("_");

                        if (helper.includes(coordinates)) {
                            let index = repeatedCoordinates.map(x3 => x3.coordinates).indexOf(coordinates);
                            if (index !== -1) {
                                repeatedCoordinates[index].count++
                            } else {
                                repeatedCoordinates.push({
                                    mapItemIndex: i,
                                    count: 2,
                                    isUsed: false,
                                    coordinates: coordinates
                                })
                            }
                        } else {
                            helper.push(coordinates)
                        }
                    });
                });

                let key = 0;
                this.mapItems?.forEach((x) => {
                    // if (!x?.coordinates) {
                    //     return
                    // }
                    x?.Services.forEach(x2 => {
                        if (
                            x2.SvKey !== 3 ||
                            isNaN(this.getHotelCoordinates(x2)[0]) ||
                            this.selectedHotels.length && !this.selectedHotels.includes(x2.Hotel.Key)
                        ) return;

                        const coordinates = this.getHotelCoordinates(x2).join("_");
                        const repeatedIndex = repeatedCoordinates.map(x3 => x3.coordinates).indexOf(coordinates);

                        if (repeatedIndex !== -1) {
                            if (!repeatedCoordinates[repeatedIndex].isUsed) {
                                repeatedCoordinates[repeatedIndex].isUsed = true;
                                x.count = repeatedCoordinates[repeatedIndex].count;
                            } else {
                                return;
                            }
                        }

                        x.open = this.selectedHotelsOnMap.includes(x2.Hotel.Key);

                        const coord = this.focusedInListView ? this.focusedInListView : x2;
                        const myIcon = this.L.divIcon({html: this.markerHtml(x, coord)});
                        this.markers.push(this.L.marker(this.getHotelCoordinates(coord), {icon: myIcon}).addTo(this.mymap));

                        this.minPriceItem = x.Cost < this.minPriceItem.Cost || key === 0 ? x : this.minPriceItem;
                        key++
                    })
                });

                this.setMarkersEvent();
                this.setCenterToMinPrice()
            },
            markerHtml(tourData, hotelService) {
                let active = false;
                if (tourData.open || this.showOnlySelected) {
                    active = true
                }
                return `
${style}
<div class="marker-wrap">
    <div class="marker hover ${active ? 'active' : ''}">
        <h6 class="label">${this.localizeList.fromPrice} ${this.correctPrice(tourData.Cost)} ${this.rate.Code}</h6>
        <span style="display:none;">${hotelService.Hotel.Value}, ${hotelService.Stars.Value}</span>
        <div class="bottom-angle"></div>
    </div>
 </div>
        `;
            },
            getDepartureCity(item) {
                return item.CityDepature.Value;
            },
            getHotelCity(item) {
                let res = "";
                item.Services.forEach(x => {
                    if (x.Hotel) {
                        res = x.City.Value
                    }
                });

                return res;
            },
            getHotelName(item) {
                let res = "";
                item.Services.forEach(x => {
                    if (x.Hotel) {
                        res = x.Hotel.Value;
                        return;
                    }
                });

                return res;
            },
            getHotelStars(item) {
                let res = 0;
                item.Services.forEach(x => {
                    if (x.Hotel) {
                        res = this.getStars(x.Stars.Value) ? this.getStars(x.Stars.Value) : x.Stars.Value;
                        return;
                    }
                })
                return res;
            },
            getStars(val) {
                if (!val) {
                    return val
                }
                let res = 0;
                let stars = parseInt(val[0]);
                if (typeof stars === "number" && !isNaN(stars)) {
                    res = stars
                }
                return res
            },
        },
        watch: {
            isDarkTheme() {
                this.setTheme()
            },
            mapItems(val) {
                if (checkEquality(val, this.mapItemsOld))
                    return;

                this.mapItemsOld = fullCopy(val)

                const hasCoordinates = val.filter(x => x?.coordinates);
                if (!hasCoordinates.length && !this.zoomIsSet && !this.isFocusedInListViewHasCoord) {
                    this.mymap.panTo(new this.L.LatLng(0,0));
                    this.mymap.setZoom(2);
                }
                setTimeout(() => {
                    this.addMarkers();
                },0)
            },
            focused(val) {
                if (this.number !== 2 && val !== null && val.coordinates) {
                    this.mymap.panTo(new this.L.LatLng(...val.coordinates));
                }
            },
            focusedInListView(val) {
                  if (val !== null && val.Latitude && val.Longitude) {
                      this.addMarkers();
                      this.mymap.setZoom(16);
                      this.mymap.panTo(new this.L.LatLng(...this.getHotelCoordinates(val)));
                  } else if (val && !val.Latitude && !val.Longitude) {
                      this.addMarkers();
                      this.mymap.setZoom(2);
                      this.mymap.panTo(new this.L.LatLng(0,0));
                  } 
            }
        }
    }
</script>

<style scoped>
    .map-content,
    #map1,
    #map2{
        width: 100%;
        height: 100%;
    }
</style>
